import React, { Fragment, useState } from "react";
import { Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import ApplicationList from "./ApplicationList";
import ApplicationFilters from "./ApplicationFilters";

const StudentApplicationsPage = () => {
  const [activeFilter, setActiveFilter] = useState<number>(0);
  const { t } = useTranslation();

  const handleTabChange = (_: any, { activeIndex }: any) => {
    setActiveFilter(activeIndex);
  };

  return (
    <Fragment>
      <Message info content={t("applications.student.approval_info")} />
      <ApplicationFilters handleTabChange={handleTabChange} />
      <ApplicationList activeFilter={activeFilter} />
    </Fragment>
  );
};

export default StudentApplicationsPage;
